import { render, staticRenderFns } from "./DonutChart51.vue?vue&type=template&id=186a4e76&scoped=true"
import script from "./DonutChart51.vue?vue&type=script&lang=js"
export * from "./DonutChart51.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a4e76",
  null
  
)

export default component.exports